import { Component, OnInit } from '@angular/core';
import { AdminService } from '../../../../../core/services/admin.service';
import { AppNotifyService } from 'src/app/core/services/app-notify.service';
import { NotifyType } from 'src/app/core/enums/NotifyType';
import { LanguageTranslationService } from '../../../../../core/services/language-translation.service';
import { FormGroup, FormControl, FormBuilder } from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser';
import { FileRestrictions } from '@progress/kendo-angular-upload';
import { environment } from '../../../../../../environments/environment';

@Component({
  selector: 'app-pre-installation-system-admin',
  templateUrl: './pre-installation-system-admin.component.html',
  styleUrls: ['./pre-installation-system-admin.component.scss']
})
export class PreInstallationSystemAdminComponent implements OnInit {

  description: string = "";
  userLanguage: string = "";
  enableText: boolean = false;
  id: any;
  getLanguages: any;
  trainingForm: FormGroup;
  selectedLanguage: string = "";
  preInstallationInputMethod = 'TextEditor';
  preInstallationUrlPath= null;
  preInstallationUrl = null;

  constructor(private adminService: AdminService, private formBuilder: FormBuilder, private appNotifyService: AppNotifyService,
    private languageService: LanguageTranslationService, private sanitizer: DomSanitizer) { }

  ngOnInit() {
    this.trainingForm = this.formBuilder.group({
      id: new FormControl(0),
      description: new FormControl(""),
      languageCode: new FormControl(""),
    })
    this.languageService.getLanguages().subscribe(response => {
      this.getLanguages = response;
    })
    this.selectedLanguage = localStorage.getItem('language');
    this.lanaguageChange("");
  }

  //#region label/variable declaration
  public preInstallation = {
    languageLbl: 'Language',
    descriptionLbl: 'Description',
    isSubmitted: false,
    isLanguageCodeEmpty: false,
    isDescriptionEmpty: false,
    isEmptyPreInstallationUrlPath: false,
  }
  //#endregion
  //#region save/cancel button operations
  lanaguageChange(event) {
    const body = {
      trainingType: "preInstallation",
      languageCode: event ? event.languageCode : this.selectedLanguage
    }
    this.preInstallation.isLanguageCodeEmpty = false;
    this.adminService.getTrainingPagesDescription(body).subscribe(response => {
      this.enableText = true;
      if (response.length > 0) {
        this.trainingForm.controls.id.setValue(response[0].trainingId);
        this.transformPreInstallation(response[0]);
        this.trainingForm.controls.description.setValue(response[0].description);
        this.preInstallation.isDescriptionEmpty = false;
      } else {
        this.trainingForm.controls.description.reset();
      }
    })
  }
  transformPreInstallation(preInstallation: any) {
    
    if (preInstallation) {
      if (preInstallation.urlPath) {
        this.preInstallationUrl = this.sanitizer.bypassSecurityTrustResourceUrl(environment.imageUrl + preInstallation.urlPath);
        this.preInstallationInputMethod = "FileUpload";
      } else {
        this.preInstallationInputMethod = "TextEditor";
        this.preInstallationUrl = null;
      }
    }
  }

  public validatePreInstallationForm(): boolean {
    let isValid = true;
    const controls = this.trainingForm.controls;
    if (this.preInstallation.isSubmitted) {
      if (controls.languageCode.value) {
        this.preInstallation.isLanguageCodeEmpty = false;
      } else {
        this.preInstallation.isLanguageCodeEmpty = true;
        isValid = false;
      }
      if (this.preInstallationInputMethod === "FileUpload") {
        if (this.preInstallationUrlPath) {
          this.preInstallation.isEmptyPreInstallationUrlPath = false;
        } else {
          this.preInstallation.isEmptyPreInstallationUrlPath = true;
          isValid = false;
        }
      } else {
        if (controls.description.value) {
          this.preInstallation.isDescriptionEmpty = false;
        } else {
          this.preInstallation.isDescriptionEmpty = true;
          isValid = false;
        }
      }
     
    }
    return isValid;
  }
  resetForm() {
    this.trainingForm.reset();
    this.enableText = false;
    this.preInstallation.isSubmitted = false;
    this.preInstallation.isLanguageCodeEmpty = false;
    this.preInstallation.isDescriptionEmpty = false;
    this.preInstallation.isEmptyPreInstallationUrlPath = false;
    this.selectedLanguage = "";
    this.preInstallationUrlPath = null;
    this.preInstallationUrl = null;
    this.preInstallationInputMethod = "TextEditor";
  }
  savePreInstallationDescription() {
    this.preInstallation.isSubmitted = true;
    if (!this.validatePreInstallationForm()) {
      return;
    }
    const controls = this.trainingForm.controls;
   
      const body = {
        description: controls.description.value,
        trainingId: controls.id.value,
        trainingType: "preInstallation",
        urlPath: this.preInstallationUrlPath,
        languageCode: controls.languageCode.value ? controls.languageCode.value.languageCode : this.selectedLanguage,
      }
      this.adminService.saveTrainingPagesDescription(body).subscribe(response => {
        this.appNotifyService.notify(NotifyType.SUCCESS, 'Saved successfully!');
        this.selectedLanguage = body.languageCode;
        this.lanaguageChange("");
      })
   

  }
  fileRestrictions: FileRestrictions = {
    allowedExtensions: [".pdf"],
  };
  preInstallationSelected(event) {
    console.log(event);
  }
  preInstallationUploadSuccess(event) {
    console.log(event);
    this.preInstallationUrlPath = event.response.body.paths[0];
    if (this.preInstallationUrlPath) {
      const url = environment.imageUrl + `/api/${this.preInstallationUrlPath}`;
      this.preInstallationUrl = this.sanitizer.bypassSecurityTrustResourceUrl(url.replace("\\", "/"));
      this.preInstallationInputMethod = "FileUpload";
    } else {
      this.preInstallationInputMethod = "TextEditor";
    }

  }
}
